module.exports = __webpack_public_path__ + "static/media/icon-punch.4a62ae80.svg";